import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PtlWindowLocationService } from '@ptl/global-components';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { OnExchangePlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';

@Component({
    selector: 'app-warn-enroll-non-silver',
    templateUrl: './warn-enroll-non-silver.component.html',
    styleUrls: ['./warn-enroll-non-silver.component.scss'],
    standalone: false
})
export class WarnEnrollNonSilverComponent implements OnInit {

  constructor(
    private windowLocationService: PtlWindowLocationService,
    private eligibilityManagerService: EligibilityManagerService,
    private dialogRef: MatDialogRef<WarnEnrollNonSilverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      showCSRWarning: boolean,
      showAPTCWarning: boolean,
      plan: Product<OnExchangePlanAttributes, SummaryView>
    }
  ) { }

  ngOnInit(): void {
  }

  continueToEnrollment() {
    this.eligibilityManagerService.updateIndividualResponsibilityAmount(
      this.data.plan.price as string,
      (this.data.plan.attributes as OnExchangePlanAttributes).EHB
    );
    this.dialogRef.close(true);
  }
  closeModal() {
    this.dialogRef.close(false);
  }
}
